import { render } from "./TagStatus.vue?vue&type=template&id=55c550af&scoped=true"
import script from "./TagStatus.vue?vue&type=script&lang=js"
export * from "./TagStatus.vue?vue&type=script&lang=js"

import "./TagStatus.vue?vue&type=style&index=0&id=55c550af&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c550af"]])

export default __exports__